import { render, staticRenderFns } from "./PeopleSetMemberships.vue?vue&type=template&id=7948f0bc&"
import script from "./PeopleSetMemberships.vue?vue&type=script&lang=js&"
export * from "./PeopleSetMemberships.vue?vue&type=script&lang=js&"
import style0 from "./PeopleSetMemberships.vue?vue&type=style&index=0&id=7948f0bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports